import React from 'react';
import parse from 'html-react-parser';

import { HeroBanner } from 'src/components/molecules/HeroBanner/HeroBanner';
import type { HeroBannerProps } from 'src/components/molecules/HeroBanner/types';
import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import { trackLinkClick } from 'src/tracking/common/banner';
import { trackImpression } from 'src/tracking/common/trackImpression';
import type { TrackingContext } from 'src/types/TrackingContext';
import * as styles from './DepartmentHeroBannerSection.style';

const parseOptionalHtmlString = (html: string) => {
  const reactNodes = parse(html);
  return !Array.isArray(reactNodes) ? reactNodes : undefined;
};

export interface DepartmentHeroBannerSectionProps extends Omit<HeroBannerProps, 'buttonHref'> {
  subHeading?: string;
  trackingPosition?: number;
  trackingTitle: string;
}

export const DepartmentHeroBannerSection = ({
  subHeading,
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: DepartmentHeroBannerSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Hero banner',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper}>
      <HeroBanner
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext, 'Link')}
        onVisible={() => trackImpression(trackingContext)}
        subHeading={subHeading && parseOptionalHtmlString(subHeading)}
        {...restOfProps}
      />
    </SectionContainer>
  );
};
